import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import clienteAuthService from '../api/authService';

export default function ClienteForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      await clienteAuthService.forgotPassword(email);
      setSuccess('Se l\'email è registrata, riceverai le istruzioni per reimpostare la password.');
      setTimeout(() => navigate('/area-riservata/login'), 5000);
    } catch (err) {
      setError(err.response?.data?.message || 'Errore durante la richiesta. Riprova.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FFFEFA] flex items-center justify-center px-4">
      <div className="w-full max-w-md mang-card p-8">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Password dimenticata</h1>
        <p className="text-gray-500 text-sm mb-6">Inserisci la tua email per ricevere il link di reset.</p>
        {success && <div className="bg-green-50 text-green-700 text-sm p-3 rounded-lg mb-4">{success}</div>}
        {error && <div className="bg-red-50 text-red-700 text-sm p-3 rounded-lg mb-4">{error}</div>}
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Email</label>
            <input type="email" required className="w-full border rounded-xl px-4 py-2.5" value={email}
              onChange={(e) => setEmail(e.target.value)} disabled={loading || !!success} />
          </div>
          <button type="submit" disabled={loading || !!success}
            className="w-full bg-[#c78244] text-white py-3 rounded-xl font-semibold hover:opacity-90 disabled:opacity-50">
            {loading ? 'Invio…' : 'Invia link'}
          </button>
        </form>
        <p className="text-center text-sm text-gray-500 mt-4">
          <Link to="/area-riservata/login" className="text-[#c78244] underline">← Torna al login</Link>
        </p>
      </div>
    </div>
  );
}
